module.exports = __webpack_public_path__ + "static/media/facebook.62d4d790.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/Footer/assets/facebook.svg
// module id = 37
// module chunks = 0